module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('a-icon', {
    attrs: {
      "type": "copyright",
      "color": "#C4C5C6",
      "size": "18"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "copyright-span",
    domProps: {
      "innerHTML": _vm._s(_vm.copyright + "&emsp;&emsp;" + _vm.ICP)
    }
  })], 1)]), _vm._v(" "), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "privacy"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3a663328","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/login/Footer.vue
// module id = Gda8
// module chunks = 273